import { Nullable } from "../../common/types/types";
import { APP_MODE, CONFIG_ROLES, IConfigState, IStallMode } from "./types";

export const fairpriceUUID = new Set([
	"e777aea9-647d-404b-91ee-010d52710918",
	"6d0a8acd-216b-4168-85c8-5d6fbeff8d9b",
]);
const flintUUID = new Set([
	"31686b93-1e40-4787-a426-2a0ef935d1ee",
	"628907cd-ba9d-43a4-a6ff-3ec8b391958f",
	"2e33bfb7-f9bb-4442-aa4d-43d16df50a07",
]);

const torikizokuUUID = new Set([
	"3d234cba-026f-445e-abec-9e9bf5e8488a",
	"9849e7ad-3c6e-4fa4-9e4d-8646e70173a3",
	"4f74ac49-c13c-40a9-befc-731bda41cc8d",
	"1aa12687-3935-4801-9f6e-acbd1d4e04eb",
]);

const shabudayUUID = new Set([
	"ced818fe-1924-40cf-b22c-63882b55c1a1",
	"4e6b3876-f36c-4f69-a354-5bf6266d2bff",
	"a4050d36-75cb-4ef3-913a-fa34eb79babf",
]);
const kokoroUUID = new Set([
	"d61d4e7c-18ba-4510-bd44-49a39669a965",
	"3d414ade-b800-4685-bf6d-70abcbd794b1",
]);
const wangUUID = new Set(["6ab9e5f0-e4da-4187-b767-b72abb410a2e"]);

// Maps a UUID to its brand base path. Order mirrors getDefaultStallMode below
// so a UUID that appears in multiple sets resolves to the same brand consistently.
export const getBrandPath = (uuid: string): string | null => {
	if (!uuid) return null;
	if (torikizokuUUID.has(uuid)) return "/torikizoku";
	if (fairpriceUUID.has(uuid)) return "/pdd";
	if (flintUUID.has(uuid)) return "/flint";
	if (wangUUID.has(uuid)) return "/wang";
	if (shabudayUUID.has(uuid)) return "/shabudays";
	if (kokoroUUID.has(uuid)) return "/kokoro";

	return null;
};

// Force stallMode based on domain name in production
const getStallMode = (
	fallbackMode: Nullable<IStallMode>,
	isProduction?: boolean
): Nullable<IStallMode> => {
	if (typeof globalThis === "undefined" || !globalThis.location) {
		return fallbackMode;
	}

	const hostname = globalThis.location.hostname;
	let prodMode = isProduction;

	if (prodMode === undefined) {
		try {
			// Use eval to avoid syntax error during Jest parsing
			prodMode = eval("import.meta.env.MODE") === "production";
		} catch {
			prodMode = false;
		}
	}

	if (prodMode && hostname.includes("heavenlywang")) {
		return IStallMode.WANG;
	}

	return fallbackMode;
};

const getDefaultStallMode = (): Nullable<IStallMode> => {
	if (typeof globalThis === "undefined" || !globalThis.location) {
		return null;
	}

	const urlParams = new URLSearchParams(globalThis.location.search);
	const uuid = urlParams.get("uuid") ?? "";

	if (uuid.length === 0) return null;
	if (torikizokuUUID.has(uuid)) {
		return IStallMode.TORIKIZOKU;
	}
	if (fairpriceUUID.has(uuid)) {
		return IStallMode.FAIRPRICE;
	}
	if (flintUUID.has(uuid)) {
		return IStallMode.FLINT;
	}
	if (wangUUID.has(uuid)) {
		return IStallMode.WANG;
	}
	if (shabudayUUID.has(uuid)) {
		return IStallMode.SHABUDAY;
	}
	if (kokoroUUID.has(uuid)) {
		return IStallMode.KOKORO;
	}

	return IStallMode.NULL;
};

export const initialState: IConfigState = {
	user: {
		session_id: "getSessionId",
		role: CONFIG_ROLES.GUEST,
	},
	theme: "light",
	table: null,
	location: {
		id: "",
		name: "Default Location",
		outletid: "outletId",
		description: "Default Description",
	},
	config: {
		stall: { mode: getDefaultStallMode(), name: "", image_url: "", address: [] },
		banner: [],
		enable_qrokoro: true,
		takeaway_fee: 0,
		bcrs_deposit_rate: 10, // 0.1 dollar = 10 cents
		showBanner: false,
		VDPfooter: null,
		adyen_merchant_name: null,
		allow_takeaway: false,
		show_virtual_category: false,
		virtual_category: [],
		allow_virtual_items: false,
		show_category_description: false,
	},
	isLoading: false,
	errorMessage: null,
	count: 0,
	// Empty until the location loads: a method that is not listed is not offered.
	paymentMethods: [],
	stallMode: getDefaultStallMode(),
	appMode: APP_MODE.VIEW,
	inited: false,
	qrSession: null,
};

export { getStallMode };
